export default function payments(
  initialState = {
    payments: [],
    search: '',
    activeSort: '',
    sortOrder: '',
    totalCount: 0,
    page: 1
  },
  action
) {
  switch (action.type) {
    case 'SET_SUPER_ADMIN_PAYMENTS':
      return {
        ...initialState,
        payments: action.payload,
      };

    case 'SET_SUPER_ADMIN_PAYMENTS_SEARCH':
      return {
        ...initialState,
        search: action.payload,
      };

    case 'SET_SUPER_ADMIN_PAYMENTS_ACTIVE_SORT':
      return {
        ...initialState,
        activeSort: action.payload,
      };

    case 'SET_SUPER_ADMIN_PAYMENTS_SORT_ORDER':
      return {
        ...initialState,
        sortOrder: action.payload,
      };

    case 'SET_SUPER_ADMIN_PAYMENTS_TOTAL_COUNT':
      return {
        ...initialState,
        totalCount: action.payload,
      };

    case 'SET_SUPER_ADMIN_PAYMENTS_PAGE':
      return {
        ...initialState,
        page: action.payload,
      };

    case 'SUPER_ADMIN_PAYMENTS_RESET':
      return {
        ...initialState,
        payments: [],
        search: '',
        activeSort: '',
        sortOrder: '',
        totalCount: 0,
        page: 1
      };

    default:
      return initialState;
  }
}
